















































































import Vue, { PropType } from "vue";
import { mapActions, mapGetters, mapState } from "vuex";
import { RootState } from "@/store";

import DeviceTree from "@/components/DeviceTree/index.vue";

import { FETCH_UPDATE_PACKAGES_LIST } from "@/store/modules/UpdatePackagesModule/actions";
import { EditPackageTargetInstallationsReqData } from "@/model/communication/updatePackages/EditPackageTargetInstallationsReqData";
import { DeviceTreeNode, FolderDeviceTreeNode, InstallationDeviceTreeNode } from "@/model/data/deviceTree/DeviceTreeNode";
import { DeviceTreeNodeTypeEnum } from "@/model/data/deviceTree/DeviceTreeNodeTypeEnum";
import { EditPackageTargetInstallationsCommand } from "@/model/communication/updatePackages/EditPackageTargetInstallationsCommand";
import { GetPackageTargetInstallationsCommand } from "@/model/communication/updatePackages/GetPackageTargetInstallationsCommand";
import { UpdatePackage } from "@/model/data/updates/UpdatePackage";
import { Organization } from "@/model/data/organizations/Organization";
import { ClientPrivileges } from "@/model/data/authentication/ClientPrivilegesEnum";

export default Vue.extend({
    components: { DeviceTree },
    props: {
        updatePackage: Object as PropType<UpdatePackage>,
        visibleOrganizations: Array as () => Array<Organization>,
    },
    data() {
        return {
            newTargetInstallationsName: [],
            targetInstallationsLoading: false,
            targetOrganizationsLoading: false,
            newTargetInstallations: [],
            editPackageLoading: false,
            newTargetOrganizations: [],
            orgSearch: "",
        };
    },
    computed: {
        ...mapState({
            deviceTree: (state: RootState) => state.devices.deviceTree,
            authUser: (state: RootState) => state.authMod.currentUser,
        }),
        ...mapGetters(["totalDevicesInTree", "authUserHasPrivilege"]),

        treeTitle: function () {
            let res = this.$t("common.devices_selected") + ": ";
            res = res.concat(this.newTargetInstallations != null ? this.newTargetInstallations.filter((t) => t.type == DeviceTreeNodeTypeEnum.Device).length : 0);
            res = res.concat("/");
            res = res.concat(this.totalDevicesInTree);
            return res;
        },
        newTargetOrganizationsId() {
            if (this.newTargetOrganizations && this.newTargetOrganizations.length) return this.newTargetOrganizations.map((org) => org.id);
            return [];
        },
        organizationsManagementEnabled() {
            return this.authUserHasPrivilege(ClientPrivileges.OrganizationsManagement) && this.visibleOrganizations && this.visibleOrganizations.length > 1;
        },
        sortedFilteredVisibileOrg() {
            if (this.visibleOrganizations && this.visibleOrganizations.length) {
                let filteredOrg = [];
                if (this.orgSearch && this.orgSearch.length && this.orgSearch.trim().length)
                    filteredOrg = this.visibleOrganizations.filter((o) => o.name.toLocaleLowerCase().includes(this.orgSearch.trim().toLocaleLowerCase()));
                else filteredOrg = [...this.visibleOrganizations];
                filteredOrg.sort((a, b) => a.name.localeCompare(b.name));
                return filteredOrg;
            }
            return [];
        },
    },
    watch: {
        updatePackage: {
            async handler(newValue) {
                this.newTargetInstallations = [];
                this.orgSearch = "";
                if (newValue) {
                    this.targetInstallationsLoading = true;
                    this.newTargetInstallationsName = await new GetPackageTargetInstallationsCommand(newValue.id).execute();
                    this.targetInstallationsLoading = false;
                    this.newTargetOrganizations.splice(0);
                    newValue.targetOrganizations.forEach((org) => {
                        this.newTargetOrganizations.push(org);
                    });
                }
            },
            immediate: true,
            deep: true,
        },
        newTargetInstallationsName(newValue) {
            let completeNodes = [];
            let checkNode = function (node: DeviceTreeNode, initialValues: any) {
                if (node.type == DeviceTreeNodeTypeEnum.Device) {
                    initialValues.forEach((initialValue) => {
                        if (node.id == initialValue || node.name == initialValue) {
                            let temp: InstallationDeviceTreeNode = new InstallationDeviceTreeNode(null);
                            temp.id = node.id;
                            temp.type = node.type;
                            temp.name = node.name;
                            temp.license = (node as InstallationDeviceTreeNode).license;
                            completeNodes.push(temp);
                        }
                    });
                } else if (node.type == DeviceTreeNodeTypeEnum.Folder && (node as FolderDeviceTreeNode).children && (node as FolderDeviceTreeNode).children.length > 0) {
                    (node as FolderDeviceTreeNode).children.forEach((childNode) => {
                        checkNode(childNode, initialValues);
                    });
                }

                return null;
            };

            if (newValue && newValue.length > 0) {
                completeNodes = [];
                this.deviceTree.forEach((node: DeviceTreeNode) => {
                    checkNode(node, newValue);
                });
                this.newTargetInstallations = completeNodes;
            }
        },
    },
    methods: {
        ...mapActions([FETCH_UPDATE_PACKAGES_LIST]),
        toggleOrganization(organization: Organization) {
            if (organization.id == this.authUser.profile.organizationId) return;
            if (this.newTargetOrganizationsId.includes(organization.id)) {
                let orgIndex = this.newTargetOrganizations.findIndex((o) => o.id == organization.id);
                if (orgIndex >= 0) this.newTargetOrganizations.splice(orgIndex, 1);
            } else this.newTargetOrganizations.push(organization);
        },
        selectAll() {
            this.newTargetOrganizations.splice(0);
            this.visibleOrganizations.forEach((org) => {
                this.newTargetOrganizations.push(org);
            });
        },
        deselectAll() {
            this.newTargetOrganizations.splice(0);
            let userOrg = this.visibleOrganizations.find((o) => o.id == this.authUser.profile.organizationId);
            this.newTargetOrganizations.push(userOrg);
        },
        async onSaveClick() {
            this.editPackageLoading = true;
            let names = [];
            if (this.newTargetInstallations != null && this.newTargetInstallations.length > 0)
                names = this.newTargetInstallations.filter((d) => d.type == DeviceTreeNodeTypeEnum.Device).map((d) => d.name);
            await new EditPackageTargetInstallationsCommand(new EditPackageTargetInstallationsReqData(this.updatePackage.id, names, this.newTargetOrganizationsId)).execute();
            this.editPackageLoading = false;
            this[FETCH_UPDATE_PACKAGES_LIST]();

            this.$emit("close");
        },
    },
});
